/* Copyright (c) 2017 Backpack Health LLC */

import { AppMenu } from './AppMenu';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import './AppMenu.scss';
import { CloseButton } from '../../components/buttons/Buttons';
import { actions as systemModalActions } from '../../redux/ducks/systemModal';

@withRouter
@connect()
export class SlidingAppMenu extends React.Component<{ dispatch? }, { closed: boolean }> {
  state = {
    closed: true, // used to reset AppMenu's state
  }

  render() {
    return (
      <div className="cmp-sliding-app-menu">
        <div className="control">
          <CloseButton onClick={this.close} hasBorder={true}/>
        </div>

        <div className="content profile-background-color-accent">
          <AppMenu
            key={'' + this.state.closed}
            avatarSize={41}
          />
        </div>
      </div>
    );
  }

  close = () => {
    this.props.dispatch(systemModalActions.hideAppMenu());
    // make reset happen after animation end
    setTimeout(() => {
      this.setState({ closed: !this.state.closed });
    }, 400);
  }
}
